// Import necessary dependencies
import React, { memo, useState } from "react";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import {
  Box,
  Typography,
  Button,
  Stack,
  Paper,
  Divider,
  Grid,
  Card,
  IconButton,
} from "@mui/material";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Register Chart.js components
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const GymRevenueChart = ({revenueData,show,showMonth}) => {
  const [filter, setFilter] = useState("12 months");
  const [monthData,setMonthData] = useState([])
  const [allData,setAllData] = useState([])
  const navigate = useNavigate()


  useEffect(()=>{
     setAllData(revenueData)
     setMonthData(revenueData?.monthlyData)
  
     
  },[revenueData])


   

  const months = monthData?.map((d) => d.month);
  const revenues = monthData?.map((d) => d.totalAmount);
  const bookings = monthData?.map((d) => d.totalPasses);
//   const members = monthData.map((d) => d.members);

  const chartData = {
    labels: months,
    datasets: [
      {
        label: "Total User Spend",
        data: revenues,
        borderColor: "#4caf50",
        backgroundColor: "rgba(76, 175, 80, 0.2)",
        
        fill: true,
        tension: 0.4,
        pointRadius: 3,
        pointBackgroundColor: "#3f51b5",
      },
      {
        label: "Bookings",
        data: bookings,
        borderColor: "#3f51b5",
        backgroundColor: "rgba(63, 81, 181, 0.2)",
        fill: true,
        tension: 0.4,
        pointRadius: 3,
        pointBackgroundColor: "#4caf50",
      },
    //   {
    //     label: "Members",
    //     data: members,
    //     borderColor: "#ff9800",
    //     backgroundColor: "rgba(255, 152, 0, 0.2)",
    //     fill: true,
    //     tension: 0.4,
    //     pointRadius: 3,
    //     pointBackgroundColor: "#ff9800",
    //   },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        grid: { color: "#f0f0f0" },
        ticks: {
          callback: (value) => `$${value}`,
        },
      },
    },
  };

  return (
    <Box sx={{ padding: 4, backgroundColor: "#fff" }}>
      {/* Title and Buttons */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4" gutterBottom>
          Gym Performance Overview
        </Typography>
        {/* <Stack direction="row" spacing={1}>
          {["12 months", "30 days"].map((label) => (
            <Button
              key={label}
              variant={filter === label ? "contained" : "outlined"}
              onClick={() => setFilter(label)}
            >
              {label}
            </Button>
          ))}
        </Stack> */}
      </Stack>

      {/* Chart and Summary Side by Side */}
      <Grid container spacing={2}>
      {/* Line Chart */}
      <Grid item xs={12} md={8}>
        <Paper elevation={2} sx={{ padding: 2 }}>
          <Line data={chartData} options={options} />
        </Paper>
      </Grid>

      {/* Summary */}
      <Grid item xs={12} md={4}>
        <Stack spacing={2}>
          <Paper sx={{ padding: 2 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <Typography variant="h6">Total User Spend</Typography>
                <Typography variant="h5" color="success.main" >
                  ${show ? allData?.monthlyData[showMonth]?.totalAmount?.toFixed(2) : allData?.yearlyTotalAmount?.toFixed(2)}
                </Typography>
              </div>
              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
               onClick={()=>navigate('/gym-revenue')}
              >
                View all
              </Button>
            </div>
          </Paper>

           <Paper sx={{ padding: 2 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <Typography variant="h6">Total Flexxd Revenue</Typography>
                <Typography variant="h5" color="success.main" >
                  ${show ? (allData?.monthlyData[showMonth]?.totalAdminProfit)?.toFixed(2) : (allData?.yearlyAdminShare)?.toFixed(2)}
                </Typography>
              </div>
              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
                 onClick={()=>navigate('/gym-revenue')}
              >
                View all
              </Button>
            </div>
          </Paper>

          <Paper sx={{ padding: 2 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <Typography variant="h6">Total Bookings</Typography>
                <Typography variant="h5" color="primary" >
                  {show ? allData?.monthlyData[showMonth]?.totalPasses : allData?.yearlyTotalPass}
                </Typography>
              </div>
              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
                // href="/gym-revenue"
                onClick={()=>navigate('/gym-revenue')}
              >
                View all
              </Button>
            </div>
          </Paper>

          <Paper sx={{ padding: 2 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <Typography variant="h6">Total Users</Typography>
                <Typography variant="h5" color="warning.main">
                  {allData?.totalUsers}
                </Typography>
              </div>
              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
            
                 onClick={()=>navigate('/userlist')}
              >
                View all
              </Button>
            </div>
          </Paper>
        </Stack>
      </Grid>
    </Grid>



      <Grid container my={2} spacing={2}>
          <Grid item xs={4}>
                     <Card
                       sx={{
                         p: 3,
                         borderRadius: "10px",
                         backgroundColor: "#f2f2f2",
                       }}
                     >
                     <Grid style= {{display:'flex',alignItems:'center', margin:'-11px 5px'}}>
                     <IconButton style={{backgroundColor:'black',color:'white',margin:'1px 5px'}}
                      onClick={()=>navigate('/add-partner')}
                      >
                          {/* <Icon color="error">{ModeEditIcon}</Icon> */}
                          <PersonAddAltIcon />
                        </IconButton>

                       <Typography
                         variant="body2"
                         sx={{ fontWeight: "bold",marginLeft:'5px', textAlign: "center" ,cursor:'pointer'}}
                         onClick={()=>navigate('/add-partner')}
                       >
                         {/* {gymRevenue?.totalPasses} */}
                         Add New Gym
                       </Typography>
                     </Grid>
                      
         
                      
                     </Card>
                   </Grid>
         
                   <Grid item xs={4}>
                     <Card
                       sx={{
                         p: 3,
                         borderRadius: "10px",
                         backgroundColor: "#f2f2f2",
                       }}
                     >
                     <Grid style= {{display:'flex',alignItems:'center', margin:'-11px 5px'}}>
                     <IconButton style={{backgroundColor:'black',color:'white',margin:'1px 5px'}}
                       onClick={()=>navigate('/listBlog/addBlog')}
                      >
                          {/* <Icon color="error">{ModeEditIcon}</Icon> */}
                          <BorderColorIcon />
                        </IconButton>

                       <Typography
                         variant="body2"
                         sx={{ fontWeight: "bold",marginLeft:'5px', textAlign: "center",cursor:'pointer' }}
                         onClick={()=>navigate('/listBlog/addBlog')}
                       >
                         {/* {gymRevenue?.totalPasses} */}
                         Create A New Blog
                       </Typography>
                     </Grid>
                      
         
                     
                     </Card>
                   </Grid>
              <Grid item xs={4}>

              </Grid>     
      </Grid>

    </Box>
  );
};

export default memo(GymRevenueChart);
